<div class="page-header-container">
    <div class="page-title">
        {{'email.emailConfiguration' | translate}}
    </div>
</div>

<div class="header-buttons-box">
    <ng-container *ngIf="isLoadedData && hasData">
        <button *ngIf="activeFilterCount <= 0" class="btn white-btn text-uppercase" (click)="filterHandler()">
            {{'email.filter' | translate}}
        </button>
        
        <div class="buttons-group-box active-filters-reset" *ngIf="activeFilterCount > 0">
            <div class="btn-group" role="group">
                <button class="btn white-btn text-uppercase" (click)="filterHandler()">
                    <span>{{'email.filterActive' | translate}}</span>
                </button>
                <button class="btn white-btn" (click)="resetFiltersHandler()">
                    <span class="active-filters-badge">{{activeFilterCount}}</span>
                    <i class="app-icon icon icon-close-circle-fill icon-lg"></i>
                </button>
            </div>
        </div>
    </ng-container>
    
    <button class="btn primary-btn" (click)="navigateAddFormHandler()">
        <i class="app-icon icon icon-add icon-xl me-2"></i>
        {{'email.addNewEmail' | translate}}
    </button>
</div>

<emails-card-view
    *ngIf="tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW || !windowSizeLgUp"
    [emails]="emails"
    [props]="props"
    [viewDetails]="viewDetailsHandler"
    [deleteEmail]="deleteEmailHandler">
</emails-card-view>

<div class="d-flex flex-column justify-content-center" *ngIf="!hasData">
    <h3 class="text-center text-secondary my-4">{{'email.noEmails' | translate}}</h3>
    <div class="col-lg-6 text-center text-secondary mb-5 m-auto">
        {{'email.noEmailsDescription' | translate}}
    </div>
    <no-records-placeholder
        [noRecordsImageSrc]="NO_RECORDS_IMAGE_SRC.EMAILS"
    ></no-records-placeholder>
</div>

<div class="d-flex flex-column align-items-center my-5 my-lg-0" *ngIf="!hasFilterData">
    <no-records-placeholder
        [showNoRecordsHeader]="true"
        [isActiveFilter]="activeFilterCount > 0"
        (clickHereEvent)="resetFiltersHandler()"
    ></no-records-placeholder>
</div>
